const API_URL = process.env.API_URL;
const jwt = () => localStorage.getItem('jwt');

export const getConfigs = () =>
    fetch(`${API_URL}/config`, {
        method: 'GET',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        }
    })


export const updateConfigs = (config) =>
    fetch(`${API_URL}/config`, {
        method: 'PUT',
        mode: 'cors',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `bearer ${jwt()}`
        },
        body: JSON.stringify(config)
    })


// WEBPACK FOOTER //
// ./src/services/api/config.js